import app from '../app.first';
import $ from 'jquery';

app.MyAccount = class extends app.Component {
	constructor($this) {
        super($this);
        this.$availability = $("#availability");
        $(() => this.onDocumentReady($this));

	}

    onDocumentReady($this) {
        this.$availability.on('change', function() {
            let _agree = this.checked ? 1 : 0;
            app.ajax("/candidate/users/update.json", { agree_to_marketing: _agree }, false);
        });
    }
}